export default __webpack_public_path__ + "static/media/Group 164.3fcc251b.png";